module.exports = __webpack_public_path__ + "static/media/sound5.b71064f2.mp3";